module.exports = __webpack_public_path__ + "assets-cabinet/img/download-icon-copy.ffce56fe.svg";